import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { type TQuoteApiCredTypes, tQuoteApi } from '../standards.js'

export type btvpCredType = TQuoteApiCredTypes
export const btvpDocumentTypes = [
  'delivery-photo',
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const btvp: CarrierDef<btvpCredType> = {
  name: 'Best Overnite Express',
  scac: 'btvp',
  ...tQuoteApi,
  engineLayers: ['rating', 'pickup', 'tracking', 'documents'],
  documentTypes: btvpDocumentTypes,
}
